import { render, staticRenderFns } from "./FastSearchMenu.vue?vue&type=template&id=b4a74b4c"
import script from "./FastSearchMenu.vue?vue&type=script&lang=js"
export * from "./FastSearchMenu.vue?vue&type=script&lang=js"
import style0 from "./FastSearchMenu.vue?vue&type=style&index=0&id=b4a74b4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports